export default __webpack_public_path__ + "static/media/151.ce2c98ce.png";